    <seds-modal>
      <div content class="tour-virtual-content">
        <div class="tour-virtual-content__left">
          <img 
            class="tour-virtual-content__left__img"
            src="./assets/images/tour_virtual.webp" 
            alt="Imagem de tour virtual - Temos novidades">
        </div>
        <div class="tour-virtual-content__right">
          <h2 class="tour-virtual-content__right__title">Temos novidades!</h2>
          <p class="tour-virtual-content__right__text">
            Reorganizamos o <strong>Novo Menu de Produtos</strong> e agora ele possui todas as funcionalidades que você precisa em seu dia a dia.
            <br /> <br />
            Quer saber como ficou?
          </p>
          <div class="tour-virtual-content__right__buttons">
            <a href="javascript:;" (click)="skippedTour()">Pular tour</a>
            <button 
              eds-button motif="primary"
              data-testid="btn-iniciar-tour"
              (click)="clickModalInitTour()"
              class="tour-virtual-content__right__buttons__button"
              [routerLink]="['/']" 
              [queryParams]="{starttour: 'force'}">Iniciar tour
            </button>
          </div>
        </div>
      </div>
      <div class="footer w-100 d-flex justify-content-end" footer>
      </div>
    </seds-modal>